<div>
    <div class="device-view-title">Device View {{mode ? '('+mode+')' : ''}}</div>
    <div class="w-100 overflow-auto">
        <table mat-table [dataSource]="dataSource" style="width: 100%;">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Name</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                </td>
            </ng-container>
            <ng-container matColumnDef="mac">
                <th mat-header-cell *matHeaderCellDef>Mac Address</th>
                <td mat-cell *matCellDef="let element">{{ element.mac | uppercase }}</td>
            </ng-container>
            <ng-container matColumnDef="domain">
                <th mat-header-cell *matHeaderCellDef>Domain</th>
                <td mat-cell *matCellDef="let element">{{element.domain }}</td>
            </ng-container>
            <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef>Location</th>
                <td mat-cell *matCellDef="let element">{{element.location }}</td>
            </ng-container>
            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef>Model</th>
                <td mat-cell *matCellDef="let element">{{element.deviceMetaInfo?.deviceModel}}</td>
            </ng-container>
            <ng-container matColumnDef="firmware">
                <th mat-header-cell *matHeaderCellDef>Firmware</th>
                <td mat-cell *matCellDef="let element">{{element.statistics?.firmware ?
                    element.statistics.firmware.currentVersion:element.firmware?element.firmware: '' }}</td>
            </ng-container>
            <ng-container matColumnDef="baseLicense">
                <th mat-header-cell *matHeaderCellDef>License</th>
                <td mat-cell *matCellDef="let element">{{element.baseLicense ?
                    getLicenseLabel(element.baseLicense): '' }}</td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef>Install Date</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.createdAt | date: "M/d/yy, h:mm:ss a" }}
                </td>
            </ng-container>
            <!-- Name Column -->
            <ng-container matColumnDef="upTime">
                <th mat-header-cell *matHeaderCellDef>Up Time</th>
                <td mat-cell *matCellDef="let element">{{ element.upTime }}</td>
            </ng-container>
            <ng-container matColumnDef="lastSeen">
                <th mat-header-cell *matHeaderCellDef>Last Seen</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.lastSeen | date: "M/d/yy, h:mm:ss a" }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">
                    {{ getStatus(element.lastSeen, element.track) }}
                </td>
            </ng-container>
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef class="bg-color">Action</th>
                <td mat-cell *matCellDef="let element">
                    <div class="d-flex">
                        <mat-icon class="pointer v-align-middle" matTooltip="Edit" role="img" aria-hidden="true"
                        (click)="editDevice(element)" *ngIf="role<=3">
                            edit
                        </mat-icon>
                        <mat-icon class="pointer" matTooltip="Alerts" role="img" aria-hidden="true"
                        (click)="viewSubs(element)" *ngIf="role<=3">contacts
                        </mat-icon>
                        <mat-icon class="pointer v-align-middle" matTooltip="Website Jump" role="img" aria-hidden="true"
                        (click)="webclick(element)">
                            language</mat-icon>
                        <mat-icon class="pointer v-align-middle" matTooltip="Teminal Jump" role="img" aria-hidden="true"
                        (click)="teminalclick(element)">cast_connected</mat-icon>
                        <mat-icon class="pointer v-align-middle" matTooltip="Reset Password" role="img"
                        aria-hidden="true" (click)="resetPwd(element._id)" *ngIf="role<=3">
                            lock_reset</mat-icon>
                        <!-- <mat-icon class="pointer v-align-middle" matTooltip="Firmware Update" role="img" aria-hidden="true"
                        (click)="updateFirmware(element)" *ngIf="role<=3">memory</mat-icon> -->
                        <mat-icon class="pointer v-align-middle" matTooltip="LAN Jump 1" role="img" aria-hidden="true"
                        (click)="redirect_lan1(element)" *ngIf="role<=3 && (lan1_status)">
                            laptop</mat-icon>
                        <mat-icon class="pointer v-align-middle" matTooltip="LAN Jump 2" role="img" aria-hidden="true"
                        (click)="redirect_lan2(element)" *ngIf="role<=3 && (lan2_status)">
                            laptop</mat-icon>
                        <mat-icon class="pointer v-align-middle" matTooltip="Delete" role="img" aria-hidden="true"
                        (click)="delete(element._id)" *ngIf="role==0">
                            restore_from_trash</mat-icon>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
    <div class="mt-4" *ngIf="tabsInitialized">
        <app-monitor-tab-group [tabs]="tabs" [activeId]="selectedPath[0]" ariaLabel="Device monitor sections"
        (tabSelected)="selectTab($event)">
            <ng-template monitorTab="analytics-info">
                <app-device-monitor-analytics [device]="device" [dataSource]="dataSource" (edit)="editDevice(dataSource.data[0])"></app-device-monitor-analytics>
            </ng-template>
            <ng-template monitorTab="device-cli">
                <app-device-command-center [device]="device" [userRole]="role"></app-device-command-center>
            </ng-template>
            <ng-template monitorTab="alerts">
                <app-device-monitor-alert [device]="device"></app-device-monitor-alert>
            </ng-template>
            <ng-template monitorTab="attack-shield">
                <app-device-attack-shield [device]="device"></app-device-attack-shield>
            </ng-template>
            <ng-template monitorTab="sipwatch">
                <app-device-monitor-sipwatch [device]="device"></app-device-monitor-sipwatch>
            </ng-template>
            <ng-template monitorTab="SDWAN">
                <app-device-monitor-sdwan [device]="device" [role]="role" [tabs]="sdwanTabs" [activeId]="selectedPath[1]" (tabSelected)="selectTab($event)"></app-device-monitor-sdwan>
            </ng-template>
            <ng-template monitorTab="4glte">
                <app-device-monitor-i4glte [device]="device"></app-device-monitor-i4glte>
            </ng-template>
            <ng-template monitorTab="device-system">
                <app-device-monitor-system [device]="device" [ras]="rasData[0]" [tabs]="systemTabs" [activeId]="selectedPath[1]" [wifiActiveId]="selectedPath[2]" (tabSelected)="selectTab($event)"></app-device-monitor-system>
            </ng-template>
            <ng-template monitorTab="ras">
                <app-device-ras [device]="device"></app-device-ras>
            </ng-template>
            <ng-template monitorTab="notes">
                <app-device-notes [device]="device"></app-device-notes>
            </ng-template>
        </app-monitor-tab-group>
    </div>
</div>
